import { apiUtils } from "../../../../utils/apiUtils";
import type {
  CouponRedeemResult,
  VerifyCouponQrRawResponse,
  VerifyCouponQrRequest,
} from "../types/merchantCouponRedeemer.types";
import { toCouponRedeemResult } from "../types/merchantCouponRedeemer.types";

const verifyQrPath = "/v1/merchant/local-merchant-coupon/verify-qr";

export const merchantCouponRedeemerApi = {
  /**
   * Redeem a resident coupon by QR token.
   * POST /v1/merchant/local-merchant-coupon/verify-qr with `{ token }`.
   * `UsedDate` stays exclusively backend-owned through the conditional
   * consume operation; the frontend never writes a use date directly.
   * Unsuccessful envelopes reject with the normalized backend error.
   */
  verifyCouponQr: async (token: string): Promise<CouponRedeemResult> => {
    const request: VerifyCouponQrRequest = { token };
    const raw = await apiUtils.postData<VerifyCouponQrRawResponse>(
      verifyQrPath,
      request,
      "Failed to redeem coupon. Please try again.",
    );

    return toCouponRedeemResult(raw);
  },
};

export default merchantCouponRedeemerApi;
